import ActivityStats from '@/components/profile/ActivityStats';
import EmotionStats from '@/components/profile/EmotionStats';
import { ProfileHeader } from '@/components/profile/ProfileHeader';
import ProfileOptions from '@/components/profile/ProfileOptions';
import theme from '@/constants/theme';

export default function ProfileScreen() {
  return (
    <div style={styles.container}>
      <ProfileHeader />
      <ActivityStats />
      <EmotionStats />
      <ProfileOptions />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    backgroundColor: theme.colors.background.primary,
    flex: 1,
  },
};